export { default } from './SummaryTechnicalSheet';